module.exports = __webpack_public_path__ + "static/media/square-me-2.183e81db.jpg";